export default __webpack_public_path__ + "static/media/c-front-end.1c3f5ee3.jpg";